import { Box, Link, Typography } from "@mui/material";
import { PagePaper, SectionPaper } from "@/components/Paper";
import { PageTitle } from "@/components/Title";
import { KeyboardArrowLeft } from "@mui/icons-material";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import React from "react";
import { useFeatureFlags } from "@/configs/featureFlag";
import { AcquireBookFormUI } from "@/components/AcquireBook/AcquireBookFormUI";

export const AcquireBookPresenter: React.FC = () => {
  const { mypageTop } = useFeatureFlags();

  return (
    <PagePaper>
      <Box sx={{ display: "flex" }}>
        {/* ページタイトル */}
        <Box sx={{ display: "flex", mb: 3 }}>
          <RequestPageIcon sx={{ mr: 1 }} fontSize="large" />
          <PageTitle>地番・家屋番号から不動産登記簿を取得する</PageTitle>
        </Box>
        <Box sx={{ ml: 10 }}>
          <ul>
            <li>最新の不動産登記/図面を取得いたします</li>
            <li>取得済みの場合は、課金が発生いたしません</li>
            <li>
              所在および地番・家屋番号は登記簿記載の内容を正しく入力しなければエラーとなり取得できないケースがございます。
              詳細はこちらの
              <Link
                href="https://trustart.notion.site/4-1d114754f2df806f9991e47fdee087bd#1d114754f2df810f8650c8420f7074f3"
                target="_blank"
              >
                マニュアル
              </Link>
              をご確認ください
            </li>
          </ul>
        </Box>
      </Box>

      <SectionPaper>
        <AcquireBookFormUI mode={"normal"} />
      </SectionPaper>
      {/* 戻る */}
      <Box sx={{ mt: 2 }}>
        <Link
          href={mypageTop ? "/mypage" : "/feed"}
          sx={{ display: "inline-block" }}
        >
          <Box sx={{ display: "flex" }}>
            <KeyboardArrowLeft />
            <Typography>
              {mypageTop ? "マイページに戻る" : "不動産の権利異動検索に戻る"}
            </Typography>
          </Box>
        </Link>
      </Box>
    </PagePaper>
  );
};
